import { SWITCH_WEBSITE } from '../../ActionsConst';

const initialState = {
  websiteId: 0,
};

const websiteReducer = (state = initialState, action) => {
  switch (action.type) {
    case SWITCH_WEBSITE:
      return { ...state, websiteId: action.id };
    default:
      return state;
  }
};

export default websiteReducer;
